import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardCardComponent } from './dashboard-card.component';
import { CardModule } from 'primeng/card';

@NgModule({
  declarations: [DashboardCardComponent],
  imports: [CommonModule, CardModule],
  exports: [DashboardCardComponent],
})
export class DashboardCardModule {}
